import { TableCell, TableHead, TableRow } from '@mui/material';
import React, { memo } from 'react';
import propTypes from 'prop-types';

function TasksTableHead({ title }) {
  return (
    <TableHead>
      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
        <TableCell sx={{ width: { xs: '200px', sm: '40%' }, minWidth: '150px', fontWeight: 600 }}>
          Task Name
        </TableCell>
        {title === 'Open Tasks' ? (
          <TableCell sx={{ width: { xs: '120px', sm: '15%' }, minWidth: '100px', fontWeight: 600 }}>
            Messages
          </TableCell>
        ) : (
          <TableCell sx={{ width: { xs: '150px', sm: '25%' }, minWidth: '120px', fontWeight: 600 }}>
            Start Date
          </TableCell>
        )}
        <TableCell sx={{ width: { xs: '150px', sm: '35%' }, minWidth: '120px', fontWeight: 600, pr: 3 }}>
          Due Date
        </TableCell>
        <TableCell
          sx={{ width: { xs: '120px', sm: '15%' }, minWidth: '100px', fontWeight: 600, pr: 3 }}
          align="right"
        >
          Action
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

TasksTableHead.propTypes = {
  title: propTypes.string.isRequired,
};

export default memo(TasksTableHead);
